<img
  [width]="size === 'small' ? 45 : 63"
  [src]="'assets/images/ui/icons/augmentation/' + (level > 20 ? '20+' : level) + '.png'"
  alt="" />
